import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isCollapsed = false }) => {
  const [expandedMenus, setExpandedMenus] = useState({
    dashbaord:false,
    leadManagement: false,
    marketing: false,
    masterManagement: false,
    reports: false,
  });

  const location = useLocation();

  const toggleMenu = (menu) => {
    if (!isCollapsed) {
      setExpandedMenus((prev) => ({
        ...prev,
        [menu]: !prev[menu],
      }));
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-scroll">
        <ul className="sidebar-menu">
          {/* Dashboard */}
          <li className="treeview">
            <Link to="/dashboard" className={`menu-link ${isActive('/dashboard')}`} title="Dashboard">
              <i className="fa fa-dashboard"></i>
              {!isCollapsed && <span>Dashboard</span>}
            </Link>
          </li>

          {/* Lead Management */}
          <li className="treeview">
            <a
              href="#"
              className="menu-link"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu('leadManagement');
              }}
              title="Lead Management"
            >
              <i className="fa fa-users"></i>
              {!isCollapsed && <span>Lead Management</span>}
              {!isCollapsed && (
                <i
                  className={`fa fa-angle-left pull-right ${
                    expandedMenus.leadManagement ? 'expanded' : ''
                  }`}
                ></i>
              )}
            </a>
            {!isCollapsed && expandedMenus.leadManagement && (
              <>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/manage-leads"
                      className={`submenu-link ${isActive('/manage-leads')}`}
                    >
                      <i></i>Leads
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/leads-reassign"
                      className={`submenu-link ${isActive('/leads-reassign')}`}
                    >
                      <i></i>Leads ReAssign
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/bulk-upload"
                      className={`submenu-link ${isActive('/bulk-upload')}`}
                    >
                      <i></i>Bulk Upload
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </li>

          {/* Marketing */}
          <li className="treeview">
            <a
              href="#"
              className="menu-link"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu('marketing');
              }}
            >
              <i className="fa fa-envelope"></i>
              <span>Marketing</span>
              <i
                className={`fa fa-angle-left pull-right ${
                  expandedMenus.marketing ? 'expanded' : ''
                }`}
              ></i>
            </a>
            {expandedMenus.marketing && (
              <ul className="treeview-menu">
                <li>
                  <Link
                    to="/broadcast-email"
                    className={`submenu-link ${isActive('/broadcast-email')}`}
                  >
                    <i></i>Broadcast Email
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Master Management */}
          <li className="treeview">
            <a
              href="#"
              className="menu-link"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu('masterManagement');
              }}
            >
              <i className="fa fa-users"></i>
              <span>Master Management</span>
              <i
                className={`fa fa-angle-left pull-right ${
                  expandedMenus.masterManagement ? 'expanded' : ''
                }`}
              ></i>
            </a>
            {expandedMenus.masterManagement && (
              <>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/campaign"
                      className={`submenu-link ${isActive('/campaign')}`}
                    >
                      <i></i>Campaign
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/status"
                      className={`submenu-link ${isActive('/status')}`}
                    >
                      <i></i>Status
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/source"
                      className={`submenu-link ${isActive('/source')}`}
                    >
                      <i></i>Source
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/subsource"
                      className={`submenu-link ${isActive('/subsource')}`}
                    >
                      <i></i>SubSource
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </li>

          {/* Reports */}
          <li className="treeview">
            <a
              href="#"
              className="menu-link"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu('reports');
              }}
            >
              <i className="fa fa-line-chart"></i>
              <span>Reports</span>
              <i
                className={`fa fa-angle-left pull-right ${
                  expandedMenus.reports ? 'expanded' : ''
                }`}
              ></i>
            </a>
            {expandedMenus.reports && (
              <>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/available-unit"
                      className={`submenu-link ${isActive('/available-unit')}`}
                    >
                      <i></i>Available Unit
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/lead-listing"
                      className={`submenu-link ${isActive('/lead-listing')}`}
                    >
                      <i></i>Lead Listing
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/unit-listing"
                      className={`submenu-link ${isActive('/unit-listing')}`}
                    >
                      <i></i>Unit Listing
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/activity-summary"
                      className={`submenu-link ${isActive('/activity-summary')}`}
                    >
                      <i></i>Activity Summary
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/lead-conversion"
                      className={`submenu-link ${isActive('/lead-conversion')}`}
                    >
                      <i></i>Lead Conversion Report
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/lead-source"
                      className={`submenu-link ${isActive('/lead-source')}`}
                    >
                      <i></i>Lead Source
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/lead-source-analysis"
                      className={`submenu-link ${isActive('/lead-source-analysis')}`}
                    >
                      <i></i>Lead Source Analysis
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/leads-unattended"
                      className={`submenu-link ${isActive('/leads-unattended')}`}
                    >
                      <i></i>Leads Source Unattended
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/property-analysis"
                      className={`submenu-link ${isActive('/property-analysis')}`}
                    >
                      <i></i>Property Analysis
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/unit-floorwise"
                      className={`submenu-link ${isActive('/unit-floorwise')}`}
                    >
                      <i></i>Unit Floorwise Summary
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/lead-aging"
                      className={`submenu-link ${isActive('/lead-aging')}`}
                    >
                      <i></i>LeadAging
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/activity-listing"
                      className={`submenu-link ${isActive('/activity-listing')}`}
                    >
                      <i></i>Activity Listing
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/property-view"
                      className={`submenu-link ${isActive('/property-view')}`}
                    >
                      <i></i>Property View
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/opportunity-assigned"
                      className={`submenu-link ${isActive('/opportunity-assigned')}`}
                    >
                      <i></i>Leads Assigned Summary
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/login-report"
                      className={`submenu-link ${isActive('/login-report')}`}
                    >
                      <i></i>Login Report
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/leads-summary"
                      className={`submenu-link ${isActive('/leads-summary')}`}
                    >
                      <i></i>Leads Summary
                    </Link>
                  </li>
                </ul>
                <ul className="treeview-menu">
                  <li>
                    <Link
                      to="/marketing-platform"
                      className={`submenu-link ${isActive('/marketing-platform')}`}
                    >
                      <i></i>Marketing Platform Report
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
